import LrOt4 from '@/assets/fonts/families/land-rover-open-type/lr_ot4.landrover';

const landRoverOpenTypeFonts = [LrOt4];

export default landRoverOpenTypeFonts;
